import { add, listen, qs, qsa, toggle, contains, remove } from '@fluorescent/dom';

import { section } from '@/glow';

section('login', {
  onLoad() {
    const main = qs('[data-part="login"]', this.container);
    const reset = qs('[data-part="reset"]', this.container);
    const toggles = qsa('[data-toggle]', this.container);
    const loginError = qs('.login__error', this.container);

    const isSuccess = qs('[data-success]', this.container);
    const successMessage = qs('[data-success-message]', this.container);
    const recoverEmailDisplay = qs('[data-recover-email]', this.container);
    const requestNewLink = qs('[data-request-new-link]', this.container);

    // Save email to cookie when recover form is submitted
    const recoverForm = qs('form[action*="recover"]', this.container);
    if (recoverForm) {
      recoverForm.addEventListener('submit', function () {
        const emailInput = qs('#RecoverEmail', recoverForm);
        if (emailInput && emailInput.value) {
          document.cookie = 'ojo_recover_email=' + encodeURIComponent(emailInput.value) + ';path=/;max-age=300';
        }
      });
    }

    // On success: show success screen, read email from cookie
    if (isSuccess && successMessage) {
      // Read email from cookie
      const cookieMatch = document.cookie.match(/ojo_recover_email=([^;]+)/);
      if (cookieMatch && recoverEmailDisplay) {
        recoverEmailDisplay.textContent = decodeURIComponent(cookieMatch[1]);
        // Delete cookie after reading
        document.cookie = 'ojo_recover_email=;path=/;max-age=0';
      }

      // Show success screen, hide both login & reset wrappers
      remove(successMessage, 'hide');
      if (main) add(main, 'hide');
      if (reset) add(reset, 'hide');
    }

    // "Request new access link" → show forgot-password form
    if (requestNewLink) {
      this.requestNewLinkClick = listen(requestNewLink, 'click', function (e) {
        e.preventDefault();
        add(successMessage, 'hide');
        if (main) add(main, 'hide');
        remove(reset, 'hide');
        reset.setAttribute('aria-hidden', 'false');
        if (main) main.setAttribute('aria-hidden', 'true');
      });
    }

    if (loginError) {
      toggleView();
    }

    function toggleView(e) {
      e && e.preventDefault();
      toggle([main, reset], 'hide');

      main.setAttribute('aria-hidden', contains(main, 'hide'));
      reset.setAttribute('aria-hidden', contains(reset, 'hide'));
    }

    this.toggleClick = listen(toggles, 'click', toggleView);
  },

  onUnload() {
    this.toggleClick();
    if (this.requestNewLinkClick) this.requestNewLinkClick();
  },
});
